import type { HealthTrendPoint } from '@/domain/health';
import { formatNumberByLocale, type Locale } from '@/utils/localeFormatters';

function buildCountByDay(trend: HealthTrendPoint[]): Map<string, number> {
    const countByDay = new Map<string, number>();
    for (const point of trend) {
        if (point.count != null) {
            countByDay.set(point.day, point.count);
        }
    }
    return countByDay;
}

/**
 * The tooltip footer under the development scores that says how many fish were measured on the
 * hovered day, for `MetricChartSpec.tooltipFooterLines`. Nothing for a day without a count.
 */
export function createHealthDevelopmentMeasurementLines(
    /** The `healthModule` translation function. */
    t: (key: 'detail.common.measurements') => string,
    locale: Locale,
    parameterTrend: HealthTrendPoint[],
    chartDays: string[]
): (dataIndex: number) => string[] {
    const countByDay = buildCountByDay(parameterTrend);

    return (dataIndex) => {
        const day = chartDays[dataIndex];
        const count = day != null ? countByDay.get(day) : undefined;
        if (count == null) {
            return [];
        }
        return [`${t('detail.common.measurements')}: ${formatNumberByLocale(count, locale, 0)}`];
    };
}
